import { render, staticRenderFns } from "./juanlianji-qi.vue?vue&type=template&id=54a7a6b8"
import script from "./juanlianji-qi.vue?vue&type=script&lang=js"
export * from "./juanlianji-qi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports